import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rangos } from '@pages/fabrica-credito/interfaces/rangos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Response } from '../../../shared/interfaces/response/response';


const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
@Injectable({
  providedIn: 'root'
})
export class RangosService {
 
  private _url = environment.apiBaseUrl + 'api/Rangos/';

  constructor(private _http: HttpClient) {}

  read(clave: string): Observable<Response> {
    const url = `${this._url}${clave}`;
    return this._http.get<Response>(url);
  }

  create(model: Rangos): Observable<Response> {
    let url: string = this._url + 'Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }
  update(model: Rangos): Observable<Response> {
    let url: string = this._url + 'Update' ;
    return this._http.put<Response>(url, model, httpOption);
  }

  delete(model: Rangos): Observable<Response> {
    let url: string = this._url + 'Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }
}
